import request from '@/utils/request'

export function fetchList(query) {
  return request({
    url: 'fix/dev/repair/page',
    method: 'get',
    params: query
  })
}

export function delObj(ids) {
  return request({
    url: 'fix/dev/repair/delete',
    method: 'post',
    data: ids
  })
}

export function getObj(id) {
  return request({
    url: '/fix/dev/repair/detail',
    method: 'get',
    params: { id }
  })
}

export function confirmReceipt(data) {
  return request({
    url: '/fix/dev/repair/edit/received',
    method: 'post',
   data
  })
}

export function startRepair(data) {
  return request({
    url: '/fix/dev/repair/edit/repair',
    method: 'post',
   data
  })
}

export function completeRepair(data) {
  return request({
    url: '/fix/dev/repair/edit/complete',
    method: 'post',
    data: data
  })
}

export function editRepairItem(data) {
  return request({
    url: '/fix/dev/repair/item/edit',
    method: 'post',
    data: data
  })
}

export function sendSms(data) {
  return request({
    url: '/fix/dev/repair/send/sms',
    method: 'post',
    data: data
  })
}

export function cancelRepair(data) {
  return request({
    url: '/fix/dev/repair/edit/cancel',
    method: 'post',
    data: data
  })
}

export function returnRepair(data) {
  return request({
    url: '/fix/dev/repair/edit/return',
    method: 'post',
    data: data
  })
}

export function returnRepairMac(data) {
  return request({
    url: '/fix/dev/repair/edit/return/mac',
    method: 'post',
    data: data
  })
}

export function endRepair(data) {
  return request({
    url: '/fix/dev/repair/edit/end',
    method: 'post',
    data: data
  })
}

export function getJdLogistics(mailNo) {
  return request({
    url: '/fix/dev/repair/jd/logistics',
    method: 'get',
    params: { mailNo }
  })
}
